import { CustomPill } from '@joor/design-system'
import styled from 'styled-components'

import { OrderStatus } from '__generated__/atlas-types'

const PillWrapper = styled.div`
  line-height: 16px;
`

export const pillColorByStatus = {
  [OrderStatus.IN_PROGRESS]: 'var(--color-accent-alpha-300)',
  [OrderStatus.NOTES]: 'var(--color-accent-beta-300)',
  [OrderStatus.ALL_NOTES]: 'var(--color-accent-beta-300)',
  [OrderStatus.PENDING]: 'var(--color-warning-300)',
  [OrderStatus.APPROVED]: 'var(--color-success-300)',
  [OrderStatus.SHIPPED]: 'var(--color-accent-gamma-300)',
  [OrderStatus.RETURNED]: 'var(--color-error-300)',
  [OrderStatus.CANCELLED]: 'var(--color-error-300)',
  [OrderStatus.NOTES_WITH_QUANTITIES]: 'var(--color-accent-beta-300)',
  [OrderStatus.NOTES_WITHOUT_QUANTITIES]: 'var(--color-accent-beta-300)',
}

export const StatusPill = ({
  value,
  status,
}: {
  value: string
  status: OrderStatus
}) => {
  return (
    <PillWrapper>
      <CustomPill
        color="var(--color-primary-900)"
        bgColor={pillColorByStatus[status]}
      >
        {value}
      </CustomPill>
    </PillWrapper>
  )
}
